import { render } from "./VideoDetailsCategorySub.vue?vue&type=template&id=7a667ba9&ts=true"
import script from "./VideoDetailsCategorySub.vue?vue&type=script&lang=ts"
export * from "./VideoDetailsCategorySub.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__